import { ClassPage } from './ClassPage';
export default ClassPage;
